import { CrudModel } from './_crud';

export class SentryBindingModel extends CrudModel {
	constructor() {
		super('admin/sentry_binding');
	}
}

export default new SentryBindingModel();
